import React, { useState } from 'react';
import { Link } from "react-router-dom";
import { Row, Col, Form, Button, Alert } from 'react-bootstrap';
import axios from 'axios';

function ForgotPassword() {
    const apiUrl = process.env.REACT_APP_URL;
    const [email, setEmail] = useState('');
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(null);
    const [error, setError] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);
        setMessage(null);

        try {
            const res = await axios.post(`${apiUrl}/users/forgot_password`, { email });
            setMessage(res.data.msg);
        } catch (err) {
            setError(err.response?.data?.error || 'Error al enviar solicitud');
        }
        setLoading(false);
    };

    return (
        <div className="auth-main-content auth-bg-image">
            <div className="d-table">
                <div className="d-tablecell">
                    <div className="auth-box">
                        <Row className="align-items-center">
                            <Col md={6}>
                                <div className="form-content">
                                    <h1 className="heading">Recuperar Contrasena</h1>
                                    <p className="text-muted mb-4">
                                        Ingresa tu correo electronico y te enviaremos un enlace para restablecer tu contrasena.
                                    </p>

                                    {message && <Alert variant="success">{message}</Alert>}
                                    {error && <Alert variant="danger">{error}</Alert>}

                                    <Form onSubmit={handleSubmit}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Email</Form.Label>
                                            <Form.Control
                                                type="email"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                required
                                                disabled={loading}
                                            />
                                        </Form.Group>

                                        <div className="text-center mb-3">
                                            <Button variant="primary" type="submit" disabled={loading}>
                                                {loading ? 'Enviando...' : 'Enviar Enlace'}
                                            </Button>
                                        </div>

                                        <div className="text-center">
                                            <Link to="/login" className="text-primary">
                                                Regresar al inicio de sesion
                                            </Link>
                                        </div>
                                    </Form>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ForgotPassword;
